<svelte:head>
    <title>Invoice App | {title}</title>
    <meta name="keywords" content={keywords} />
</svelte:head>

<script>
    export let title;
    export let keywords;
</script>